module.exports = __webpack_public_path__ + "static/media/gift-gray.db579891.svg";